import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { theme } from 'common/theme'

function SigninConfirmation() {
  const handleCancel = () => {
    const closeButton = window.parent.document.querySelector(
      '#awakeningSigninConfirmationPopup .closeIcon'
    ) as HTMLElement
    closeButton.click()
  }
  return (
    <Box>
      <Box
        sx={{
          width: '600px',
          height: '200px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant='h5'
          sx={{
            mb: 4,
            fontSize: '1.5rem',
          }}
        >
          Confirm Redirect
        </Typography>

        <Typography
          variant='body1'
          sx={{
            mb: 1,
          }}
        >
          You are about to leave XtraMath and be redirected to the Awakening
          App. <br />
          Please confirm that you wish to proceed.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            mt: 'auto',
          }}
        >
          <Button onClick={handleCancel} variant='text' color='error'>
            Cancel
          </Button>
          <Button
            component='a'
            href='https://app.legendsoflearning.com/login/teachers/register/account_info'
            target='parent'
            variant='text'
            sx={{ color: 'common.black' }}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default SigninConfirmation
